// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"553":"0967a7b8","1307":"69db4369","1319":"10f306fa","1985":"2e126324","2510":"10f306fa","4811":"63c615c1","5744":"10f306fa","9937":"63c615c1"}[chunkId] + ".chunk.css";
};